var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Model, Watch } from 'vue-property-decorator';
import { UserSubject } from '@/models/UserSubject';
import DataTable from '@/components/data-table/DataTable';
import { Student } from '@/models/Student';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { formatDate as format, ratingStarHtml } from '@/support/String';
import { Year } from '@/models/Year';
import ErrorHandler from '@/support/ErrorHandler';
import AbstractUrl from '@/support/AbstractUrl';
let Finished = class Finished extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.topics = [];
        this.showReasonDialog = false;
        this.selectedUserSubject = null;
        this.selectedArea = '';
        this.selectedTopics = [];
        this.multiple = true;
        this.levelFilter = {};
        this.periodFilter = {};
        this.userFiles = [];
        this.isLoading = true;
        this.years = [];
        this.selectedYear = '';
        // @Watch('selectedArea')
        // protected selectAreasChanged(newValue: object) {
        //   const topics = this.getTopics();
        //   this.selectedTopics = [];
        //   const selectedTopics: string[] = [];
        //   topics.forEach((topic: Subject) => {
        //     if (topic.id) {
        //       selectedTopics.push(topic.id);
        //     }
        //   });
        //   this.selectedTopics = selectedTopics;
        //   this.getTopics();
        // }
    }
    get userSubjectsTableOptions() {
        return {
            sort: {
                key: 'finished',
                order: 'DESC',
            },
            headers: [
                {
                    text: this.$tc('subject.title', 2),
                    value: 'name',
                },
                {
                    text: this.$tc('subject.area.title', 2),
                    value: 'parent',
                    transform: this.areaName,
                },
                {
                    text: this.$tc('subject.topic.title', 2),
                    value: 'parent',
                    transform: this.parentName,
                },
                {
                    text: this.$tc('idp.status.finished', 2),
                    value: 'finished_at',
                    transform: (date) => {
                        return !date ? '-' : format(date, 'yyyy-LL-dd');
                    },
                },
                {
                    text: this.$t('subject.rating'),
                    value: 'rating',
                    transform: this.starRating,
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: (vc, userSubject) => {
                        this.selectedUserSubject = userSubject;
                        // console.log('userSubject', userSubject)
                        this.showReasonDialog = true;
                        this.getFile();
                    },
                },
            ],
            model: this.dataModel,
        };
    }
    get dataModel() {
        // const defaultFilter: object = { statuses: 'finished', trashed: true };
        // const typeFilter: object = this.getTypeFilter();
        // const subjectFilter: object = this.getSubjectFilter();
        // const yearFilter: object = this.getYearFilter;
        // const totalFilters = { ...defaultFilter, ...typeFilter, ...subjectFilter, ...yearFilter };
        return new UserSubject()
            .user(this.student.id)
            .include(['parent', 'finished_user'])
            .filter(this.filters)
            .sort('finished_at', 'DESC');
    }
    get filters() {
        const filter = {
            statuses: 'finished',
            trashed: true,
        };
        if (this.selectedYear) {
            const year = this.years.find((year) => {
                return year.id === this.selectedYear;
            });
            if (year) {
                filter.updated_at = [`${year.starts_at}`, `${year.ends_at}`];
            }
        }
        return filter;
    }
    get currentCurriculum() {
        return this.$store.state.curriculum;
    }
    mounted() {
        this.getYears();
    }
    // year filter
    // public get getYearFilter() {
    //   const yearFilter: any = {};
    //   if (this.selectedYear) {
    //     const year = this.years.find((year) => {
    //       return year.id === this.selectedYear;
    //     });
    //     if (year) {
    //       yearFilter['updated_at'] = [`${year.starts_at}`, `${year.ends_at}`];
    //     }
    //   }
    //   return yearFilter;
    // }
    // Type filter
    // public getTypeFilter() {
    //   const typeFilter: any = {};
    //   if ((this.levelFilter as any).value) {
    //     typeFilter['levels'] = (this.levelFilter as any).value;
    //   }
    //   if ((this.periodFilter as any).value) {
    //     typeFilter['periods'] = (this.periodFilter as any).value;
    //   }
    //   return typeFilter;
    // }
    // Get topics based on selectedArea
    // public getTopics(): Subject[] {
    //   this.topics = [];
    //   const area = this.$store.state.curriculum.subjects.find((area: Subject) => {
    //     return area.id === this.selectedArea;
    //   });
    //   if (!area) {
    //     return [];
    //   }
    //   area.children.forEach((topic: Subject) => {
    //     this.topics.push(topic);
    //   });
    //   return this.topics;
    // }
    getFile() {
        new UserSubject()
            .user(this.$route.params.id || '')
            .include(['subject', 'files'])
            .filter({ subjects: [(this.selectedUserSubject && this.selectedUserSubject.subject) || ''] })
            .all()
            .then((userFiles) => {
            const foundFiles = userFiles.find((userFile) => {
                return (userFile.subject ? userFile.subject : '') === (this.selectedUserSubject ? this.selectedUserSubject.subject : '');
            });
            if (foundFiles && foundFiles.files) {
                this.userFiles = [...foundFiles.files.default, ...foundFiles.files.finished];
            }
        });
    }
    close() {
        this.showReasonDialog = false;
        this.userFiles = [];
    }
    // Put topics in subjectFilter
    getSubjectFilter() {
        const subjectFilter = {};
        this.filters.subjects = [];
        this.selectedTopics.forEach((selectedTopic) => {
            if (selectedTopic) {
                this.filters.subjects.push(selectedTopic);
                subjectFilter.parents = this.filters.subjects;
            }
        });
        return subjectFilter;
    }
    areaName(element) {
        if (!element.id) {
            return '';
        }
        let name = '';
        this.$store.state.curriculum.subjects.forEach((area) => {
            if (!area.children) {
                return;
            }
            area.children.forEach((topic) => {
                if (topic.id === element.id && area.name) {
                    name = area.name;
                }
            });
        });
        return name;
    }
    parentName(element) {
        return element.name ? element.name : '';
    }
    starRating(element) {
        let innerHtml = '';
        if (element > 0) {
            const stars = (element / 20) - 1;
            for (let i = 0; i <= stars; i++) {
                innerHtml += ratingStarHtml();
            }
            return innerHtml;
        }
        return innerHtml = '';
    }
    getYears() {
        this.isLoading = true;
        new Year()
            .all()
            .then((years) => {
            this.years = years;
            if (this.$route.query.year) {
                this.selectedYear = this.$route.query.year;
            }
            else {
                if (years && years.length) {
                    this.selectedYear = years[years.length - 1].id;
                }
            }
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    selectedYearChanged() {
        this.setQueryParams({ year: this.selectedYear });
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Finished.prototype, "student", void 0);
__decorate([
    Watch('selectedYear'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Finished.prototype, "selectedYearChanged", null);
Finished = __decorate([
    Component({
        components: {
            DataTable,
            SelectFilter,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
        },
    })
], Finished);
export default Finished;
